import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doGet } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const SiteDetailsAction = createAsyncThunk("siteDetails",
    async (_, { rejectWithValue }) => {
        try {
            const response = await doGet(urls?.siteDetails);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

const SiteDetailsSlice = createSlice({
    name: "siteDetails",
    initialState: {
        isLoading: false,
        data: {},
        error: null
    },
    reducers: {
        SiteDetailsReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            };
        },
    },
    extraReducers: {
        [SiteDetailsAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        [SiteDetailsAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
        },
        [SiteDetailsAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },
    }
})

export const { SiteDetailsReset } = SiteDetailsSlice.actions
export default SiteDetailsSlice.reducer;